// src/store/services/coach.js
import feathersClient, {
  makeServicePlugin,
  BaseModel
} from "../../feathers-client";

class Trainee_Coach extends BaseModel {
  constructor (data, options) {
    super(data, options);
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = "Trainee_Coach";
  // Define default properties here
  static instanceDefaults () {
    return {
      id: null,
      traineeId: null,
      coachId: null,
      status: null,
      companyId:null,
      createdAt: null,
      updatedAt: null
    };
  }
}
const servicePath = "trainee-coach";
const servicePlugin = makeServicePlugin({
  Model: Trainee_Coach,
  service: feathersClient.service(servicePath),
  servicePath
});

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
});

export default servicePlugin;
